<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Promo September 2022</div>
		</div>
		<v-card outlined class="mt-3 mb-3">
			<v-data-table loading disable-pagination :headers="headers" :items="promoResults" hide-default-footer :server-items-length="promoResults.length" class="table-w-150">
				<template v-slot:item.customer_network_code="{ item }">
					<div class="pl-2 my-auto text-capitalize">{{ item.customer_network_code }}</div>
				</template>
        <template v-slot:item.customer_network_mid="{ item }">
					<div class="pl-2 my-auto text-capitalize">{{ item.customer_network_mid }}</div>
				</template>
				<template v-slot:item.customer_name="{ item }">
					<div class="pl-2 my-auto">{{ item.customer_name }}</div>
				</template>
				<template v-slot:item.contact="{ item }">
					<div class="pb-2">{{ item.customer_mobilephone }}</div>
				</template>
				<template v-slot:item.address="{ item }">
					<div class="pt-2">{{ addressText(item) }}</div>
				</template>
				<template v-slot:progress>
					<div> </div>
				</template>
			</v-data-table>
		</v-card>
    <div class="mt-5">
      <span>Total {{promoResults.length | toNumber}} Data</span>
    </div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	data() {
		return {
			headers: [
      { text: 'Kode Pelanggan', align: 'start', sortable: false,	value: 'customer_network_code'},
      { text: 'Kode Mitra', align: 'start', sortable: false,	value: 'customer_network_mid'},
			{ text: 'Nama Mitra', align: 'start', sortable: false,	value: 'customer_name'},
			{ text: 'Point Minggu 1', value: 'point_total_week1', sortable: false},
			{ text: 'Point Minggu 2', value: 'point_total_week2', sortable: false},
			{ text: 'Point Minggu 3', value: 'point_total_week3', sortable: false},
			{ text: 'Point Minggu 4', value: 'point_total_week4', sortable: false},
			{ text: 'Point Total', value: 'point_total', sortable: false},
			// { text: 'Point Gift', value: 'gift_total', sortable: false, },
			{ text: 'No. Handphone', value: 'customer_mobilephone', sortable: false},
			{ text: 'Alamat', value: 'address', width: '30%', sortable: false},
			],
		}
	},
	computed: {
		...mapState('customerList', ['promoResults']),
	},
	methods: {
		...mapActions('customerList', ['getPromoSept2022', 'exportPromoSept2022']),
		...mapMutations('customerList', ['clearDataCustomer']),

		getData() {
			this.getPromoSept2022()
		},
		exportData(){
			this.exportPromoSept2022()
		},
    addressText(customer_data) {
			var data = []
			if (customer_data) {
				if (customer_data.customer_address)
					data.push(customer_data.customer_address)
				if (customer_data.customer_subdistrict_name)
					data.push(customer_data.customer_subdistrict_name)
				if (customer_data.customer_city_name)
					data.push(customer_data.customer_city_name)
				if (customer_data.customer_province_name)
					data.push(customer_data.customer_province_name)
			}
			return data.join(', ')
		},
	},
	async created() {
		this.$store.dispatch('setPageTitle', `Promo September 2022`);
		await this.getData()
	},
	beforeDestroy(){
		this.clearDataCustomer()
	},
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>
